import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { LocalizationService } from '../../services/localization.service';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent<T> implements OnInit {
  @Input() data: T[] = [];
  @Input() loaded: boolean = true;

  @Input() empty: string = this.ls.translate('label.noChanges').toLocaleUpperCase();

  @ContentChild('major') major!: TemplateRef<{ data: T; index: number; first: boolean; last: boolean }>;
  @ContentChild('minor') minor!: TemplateRef<{ data: T; index: number; first: boolean; last: boolean }>;

  constructor(private ls: LocalizationService) {}

  ngOnInit(): void {}
}
